import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import { todayStr } from '../components/crm/crmConstants';
import { getUser, hasModule } from '../modules';

export default function Dashboard() {
  const [stats, setStats] = useState({ customers: 0, products: 0, quotes: 0, lowStock: 0, openOpps: 0, myTasks: 0, myOverdue: 0 });
  const navigate = useNavigate();

  useEffect(() => {
    const fetchStats = async () => {
      try {
        // Only ask for what this user may see; a 403 would otherwise blank every card.
        const can = (key) => hasModule(getUser(), key);
        const empty = Promise.resolve({ data: [] });
        const [customers, products, quotes, lowStock, openOpps, myTasks] = await Promise.all([
          can('customers') ? api.get('/api/customers/') : empty,
          can('products') ? api.get('/api/products/') : empty,
          can('quotes') ? api.get('/api/quotes/') : empty,
          can('inventory') ? api.get('/api/inventory/stock?low_stock_only=true') : empty,
          can('crm') ? api.get('/api/crm/opportunities?open_only=true') : empty,
          can('crm') ? api.get('/api/crm/activities?tasks_only=true&open_only=true&assigned_to_me=true') : empty,
        ]);
        const today = todayStr();
        setStats({
          customers: customers.data.length,
          products: products.data.length,
          quotes: quotes.data.length,
          lowStock: lowStock.data.length,
          openOpps: openOpps.data.length,
          myTasks: myTasks.data.length,
          myOverdue: myTasks.data.filter(t => t.due_date && t.due_date < today).length,
        });
      } catch (err) {
        console.error(err);
      }
    };
    fetchStats();
  }, []);

  const user = getUser();
  const cards = [
    { module: 'customers', label: 'Müşteriler', value: stats.customers, icon: '👥', path: '/customers' },
    { module: 'products', label: 'Ürün/Hizmetler', value: stats.products, icon: '📦', path: '/products' },
    { module: 'quotes', label: 'Teklifler', value: stats.quotes, icon: '📄', path: '/quotes' },
    { module: 'crm', label: 'Açık Fırsatlar', value: stats.openOpps, icon: '💼', path: '/crm/pipeline' },
    { module: 'crm', label: stats.myOverdue > 0 ? `Görevlerim (${stats.myOverdue} gecikmiş)` : 'Görevlerim', value: stats.myTasks, icon: '☑️', path: '/crm/tasks', alert: stats.myOverdue > 0 },
    { module: 'inventory', label: 'Düşük Stok', value: stats.lowStock, icon: '⚠️', path: '/inventory', alert: stats.lowStock > 0 },
  ].filter((card) => hasModule(user, card.module));

  return (
    <div>
      <h2 className="text-2xl font-bold text-gray-800 mb-6">Ana Sayfa</h2>
      <div className="grid grid-cols-4 gap-6">
        {cards.map((card) => (
          <div
            key={card.label}
            onClick={() => navigate(card.path)}
            className={`rounded-lg shadow p-6 flex items-center gap-4 hover:shadow-md transition-shadow cursor-pointer ${
              card.alert ? 'bg-red-50 border border-red-200' : 'bg-white'
            }`}
          >
            <div className="text-4xl">{card.icon}</div>
            <div>
              <p className={card.alert ? 'text-red-600 text-sm' : 'text-gray-500 text-sm'}>{card.label}</p>
              <p className={`text-3xl font-bold ${card.alert ? 'text-red-700' : 'text-gray-800'}`}>{card.value}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
